module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Zufikon_AG-41d764fd62ad490f2d0400d1c602e52b.svg";